import React from 'react';
import {
  DateRangeDropdownV2 as DateRangeField,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  FormField,
  SearchField
} from '@/components/custom/erp';
import { accountSearchColumns, khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { AccountModel, KhachHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  formMode: 'add' | 'edit' | 'view';
}

const BasicInfoTab = ({ formMode }: BasicInfoTabProps) => {
  return (
    <div className='p-4'>
      {/* Ngày c/từ (từ/đến) */}
      <DateRangeField label='Ngày c/từ (từ/đến)' fromDateName='ngay_ct1' toDateName='ngay_ct2' />

      {/* Số c/từ (từ/đến) */}
      <DocumentNumberRangeField formMode={formMode} label='Số c/từ (từ/đến)' fromName='so_ct1' toName='so_ct2' />

      {/* Mã khách hàng */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã NCC</Label>
        <SearchField<KhachHang>
          type='text'
          name='ma_kh'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
        />
      </div>

      {/* Tài khoản nợ */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Tài khoản nợ</Label>
        <SearchField<AccountModel>
          type='text'
          name='tk'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
        />
      </div>

      {/* Diễn giải */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Diễn giải</Label>
        <div className='w-full'>
          <FormField name='dien_giai' type='text' disabled={formMode === 'view'} />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
